import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=9d34e76e&scoped=true&"
import script from "./questionEdit.vue?vue&type=script&lang=js&"
export * from "./questionEdit.vue?vue&type=script&lang=js&"
import style0 from "./questionEdit.vue?vue&type=style&index=0&id=9d34e76e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d34e76e",
  null
  
)

export default component.exports